import { defineMeta } from '@/registry/types';

export const imageListMeta = defineMeta({
  name: 'ImageList',
  level: 'organism',
  category: 'data-display',
  classification: 'themed-mui',
  description: 'Responsive grid of images/thumbnails. Themed MUI ImageList.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'ImageList',
  muiDocs: 'https://mui.com/material-ui/react-image-list/',
  a2uiEquivalent: 'Gallery',
  importPath: '@/organisms/ImageList',
  optionalProps: ['cols', 'gap', 'rowHeight', 'variant'],
  supportedStates: ['standard', 'quilted', 'masonry', 'woven'],
  designTokens: ['radius', 'spacing'],
  accessibility: ['Provide alt text for each image.'],
  usageExamples: ['<ImageList cols={3}><ImageListItem>...</ImageListItem></ImageList>'],
  antiPatterns: ['Do not use for tabular data (use Table).'],
  llmSafe: true,
  whenToUse: ['Screenshot/evidence galleries, thumbnails'],
  whenNotToUse: ['Text-heavy lists'],
});

export default imageListMeta;
